/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import Header1 from "ui/kit/typography/Header1";
import styles from "./OriginBanner.module.scss"
import Body from "ui/kit/typography/Body";
import GoogleSignInButton from "ui/feature/login/GoogleSignInButton";
import FacebookSignInButton from "ui/feature/login/FacebookSignInButton";

const OriginBanner: React.FC = () => {
    return (
        <div className={styles.container}>
            <Header1>Play your sheet music interactively</Header1>
            <Body>Upload your sheet music, we will transform it to a digital format, then you can play it interactively.
                Use one of the options below to get started for free.</Body>
            <div className={styles.loginHolder}>
                <GoogleSignInButton/>
                <FacebookSignInButton className={styles.fbButton}/>
            </div>
        </div>
    )
}

export default OriginBanner;